"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextElementGroupPriorityList = void 0;
const harp_utils_1 = require("@here/harp-utils");
/**
 * List of {@link TextElement} groups sorted by priority.
 */
class TextElementGroupPriorityList extends harp_utils_1.GroupedPriorityList {
}
exports.TextElementGroupPriorityList = TextElementGroupPriorityList;
//# sourceMappingURL=TextElementGroupPriorityList.js.map